import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { UserModel } from 'app/views/user/models/user.model';

@Component({
    selector: 'psm-create-account',
    templateUrl: 'createAccount.component.html',
    styleUrls: ['./userViews.scss']
})

export class CreateAccountComponent {
    public email: string;
    public password: string;
    public userInfo = new UserModel();
    public isWaiting: boolean;

    private logger: Logger;

    constructor(
        private authService: AuthService,
        private router: Router,
        loggerFactory: LoggerFactory
    ) {
        this.logger = loggerFactory.create('CreateAccountComponent');
        this.userInfo.devices = [];
    }

    public async create() {
        this.isWaiting = true;
        if (await this.authService.createUser(this.email, this.password, this.userInfo)) {
            this.logger.debug('Create user with email : ' + this.email);
            this.router.navigateByUrl('/user/verifyEmail');
        }

        this.isWaiting = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/user/createAccount.component.ts